import React, { useState, useEffect } from "react";
import { Download, X } from "lucide-react";
import { Button } from "./ui/button";

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Register service worker
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show prompt only if user hasn't dismissed it recently
      const dismissed = localStorage.getItem("pwa_dismissed");
      if (!dismissed || Date.now() - parseInt(dismissed) > 7 * 86400000) {
        setShow(true);
      }
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const result = await deferredPrompt.userChoice;
    if (result.outcome === "accepted") {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem("pwa_dismissed", Date.now().toString());
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 left-3 right-3 z-50 animate-in slide-in-from-bottom-4" data-testid="pwa-install-prompt">
      <div className="bg-gradient-to-r from-green-600 to-emerald-600 rounded-xl p-3 shadow-lg shadow-green-900/20 flex items-center gap-3">
        <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0 backdrop-blur-sm">
          <Download className="h-5 w-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Install Foodz Lizts</p>
          <p className="text-xs text-white/70">Add to home screen for quick access</p>
        </div>
        <Button
          size="sm"
          onClick={handleInstall}
          className="bg-white text-green-700 hover:bg-white/90 text-xs font-semibold flex-shrink-0"
          data-testid="pwa-install-btn"
        >
          Install
        </Button>
        <button onClick={handleDismiss} className="text-white/60 hover:text-white p-1" data-testid="pwa-dismiss-btn">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
